<template>
  <div
      @click="clickBtn()"
      class="van-button van-button--default van-button--normal group-vanbtn"
  >
    <div>
      <template v-if="couponList.couponTypeDesc">
          <span style="font-size: 12px;">活动价+优惠券=<span style="font-size: 14px;">到手价{{ couponPrice(form.finalPriceCNY,couponList.couponFaceValue) }}元</span>
          </span>
      </template>
      <template v-else>
        {{ labelName }}{{ form.finalPriceCNY }}元
      </template>
    </div>
    <del class="deltip">原价￥{{ form.sellPriceCNY }}</del>
  </div>
</template>

<script>
import {listUserNurseCouponUsaApp} from "@/api/shareH5";

export default {
  name: 'Coupon',
  props: {
    isLogin:{
      type:Boolean,
      default:true
    },
    form: Object,
    labelName:String,

  },
  data:function (){
    return {
      useCourseCoupon:false,
      couponList:{
        couponTypeDesc:"",
        couponFaceValue:""
      }
    }
  },
  methods:{
    clickBtn() {
      this.$emit('buy',this.useCourseCoupon)
    },
    couponPrice(p = 0,cp = 0){
      if(cp>p){
        return 0.00
      }
      return (p-cp).toFixed(2)
    },
  },
  created() {
    let courseId = PAGE_PARAMS.courseId;
    const courseCoupon = this.form.courseCouponPoolRelationConfig
    const hasCourseCoupon =  courseCoupon && courseCoupon.couponPoolDetailVO && courseCoupon.couponPoolDetailVO.id
    if(hasCourseCoupon){
      this.useCourseCoupon = true;
      this.couponList = {couponTypeDesc:"---",couponFaceValue:courseCoupon.couponPoolDetailVO.couponFaceValueYuan}
    }
    if(!this.isLogin){
      return
    }
    listUserNurseCouponUsaApp({commodityId: courseId}).then(r => {
      if(Array.isArray(r) && r.length != 0){
        //this.couponList = r[0];
        if(hasCourseCoupon){
          if (r[0].couponFaceValue > this.couponList.couponFaceValue){
            this.couponList = r[0];
            this.useCourseCoupon = false;
          }
        }else {
          this.couponList = r[0];
        }
      }

    }).catch(_ => {})
  }
}
</script>

<style scoped lang="scss">
.deltip {
  display: block;
  font-size: 10px;
  font-weight: normal;
  margin-top: 16px;
}
.btn-ctx {
  font-size: 16px;
}
</style>
